export default __webpack_public_path__ + "static/media/640_business04-fr-mobile.9a79d9eb.png";